import { useTranslation } from 'react-i18next'

import { allLangs, defaultLang } from './config-lang'

export const useLocales = (type?: string) => {
  const { i18n, t } = useTranslation(type)

  const primaryLangCode = i18n.language.split('-')[0]

  const currentLang =
    allLangs.find((_lang) => _lang.value === primaryLangCode) ?? defaultLang

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang)
  }

  return {
    onChangeLang: handleChangeLanguage,
    t,
    currentLang,
    allLangs
  }
}
